import React from "react";
import './SearchInputList.css';
import './App.css';

const SEARCHING_MESSAGES = [
    'Searching','Searching.','Searching..','Searching...','Searching.....',
    'Matching actors','Matching actors.','Matching actors..','Matching actors....',
    'Querying data','Querying data.','Querying data..','Querying data...','Querying data....',
    'Almost there','Almost there.','Almost there..','Almost there...','Almost there....',
    'So close','So close.','So close..','So close...','So close....',
    'Sometimes it takes a while.','Sometimes it takes a while..','Sometimes it takes a while...','Sometimes it takes a while....'
];

class SearchInputList extends React.Component {
    state = {
        searchingMessageIndex: 0
    };

    searchingMessageTimer = null;

    cycleSearchingMessage = () => {
        this.setState(prev => ({
            searchingMessageIndex: (prev.searchingMessageIndex + 1) % SEARCHING_MESSAGES.length
        }));
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.isSearching && this.props.isSearching) {
            this.setState({ searchingMessageIndex: 0 });
            this.searchingMessageTimer = setInterval(this.cycleSearchingMessage, 340);
        } else if (prevProps.isSearching && !this.props.isSearching) {
            clearInterval(this.searchingMessageTimer);
            this.searchingMessageTimer = null;
        }
    }

    componentWillUnmount() {
        clearInterval(this.searchingMessageTimer);
    }

    HandleClick = (result) => {
        // console.log(`SearchInputList - Search input list item clicked: personID=${result.personID}`);
        
        // Send the search input and the selected PersonID to the DB for better search results
        try {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/SearchSelection`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    SearchInput: this.props.searchValue,
                    PersonID: result.PersonID.toString()
                })
            });
        } catch (error) {
            console.error('Error occurred while fetching search selection:', error);
        }
        
        this.props.onSelectSearchInput(this.props.position, result.PersonID, result.PersonName);
    };
    
    SearchInputListItem(result) {
        var personBirthDeathFormatted = "";
        const maxKnownForLength = 90;
        let knownFor = result.KnownFor;
        // console.log(result.KnownFor);
            
        // Only allow up to 75 characters in the "known for" section, anything longer gets cut off
        if (result.KnownFor !== undefined) {

            if (result.KnownFor > maxKnownForLength) { 
                knownFor = result.KnownFor.substring(0,(result.KnownFor - 3)) + "..."; 
            }
        }

        if (result.BirthYear !== undefined && result.DeathYear !== undefined) { personBirthDeathFormatted = `(${result.BirthYear} - ${result.DeathYear})`; }
        else if (result.BirthYear === undefined && result.DeathYear !== undefined) {personBirthDeathFormatted = `(? - ${result.DeathYear})`;}
        else if (result.BirthYear !== undefined && result.DeathYear === undefined) {personBirthDeathFormatted = `(${result.BirthYear} - )`;}

        return (
            <tr className="search-input-list-item" 
                key={result.PersonID} 
                value={result.PersonID}
                onClick={() => this.HandleClick(result)}>
                <td>
                    <tr key={result.PersonID}><td className="person-name-item">{result.PersonName} {personBirthDeathFormatted}</td></tr>
                    <tr><td className="known-for-item">{knownFor}</td></tr>
                </td>
            </tr>
        );
    }

    render() {
        if (!this.props.searchResultsVisible) {
            return null;
        } else {
            return (
                <table className="search-input-list-table" {...(this.props.searchResultsVisible) ? { display: 'none' } : {}}>
                    <tbody>
                        <tr><th className="input-text-style">{this.props.searchValue}</th></tr>
                        {this.props.isSearching && this.props.searchResults.length === 0 && (
                            <tr><td className="searching-text">{SEARCHING_MESSAGES[this.state.searchingMessageIndex]}</td></tr>
                        )}
                        {this.props.searchResults.map((result) => (
                            this.SearchInputListItem(result)
                        ))}
                    </tbody>
                </table>
                // </div>
            );
        }
    
  }
}

export default SearchInputList;